import { Component, Input } from '@angular/core';
var ImageComponent = /** @class */ (function () {
    function ImageComponent() {
    }
    ImageComponent.decorators = [
        { type: Component, args: [{
                    // tslint:disable
                    selector: 'cov-image',
                    template: "<figure class=\"a-image\" *ngIf=\"image.source && image.source.s\">\r\n\t<picture class=\"a-image__picture\"\r\n\t\t\t *ngIf=\"image.source.m\">\r\n\t\t<source *ngIf=\"image.source.l\" [attr.data-srcset]=\"image.source.l\" media=\"(min-width: 1025px)\" />\r\n\t\t<source *ngIf=\"image.source.m\" [attr.data-srcset]=\"image.source.l\" media=\"(min-width: 650px)\" />\r\n\t\t<img class=\"a-image__img lazyload\" [alt]=\"image.alt\" [attr.data-srcset]=\"image.source.s\" [src]=\"image.source.s\"/>\r\n\t\t<noscript>\r\n\t\t\t<img class=\"a-image__img\" [alt]=\"image.alt\" src=\"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==\" [attr.data-src]=\"image.source.s\"/>\r\n\t\t</noscript>\r\n\t</picture>\r\n\t<img *ngIf=\"!image.source.m\" class=\"a-image__img lazyload\" [alt]=\"image.alt\" [attr.data-srcset]=\"image.source.s\" [src]=\"image.source.s\"/>\r\n</figure>\r\n"
                }] }
    ];
    ImageComponent.propDecorators = {
        image: [{ type: Input }]
    };
    return ImageComponent;
}());
export { ImageComponent };
//# sourceMappingURL=image.component.js.map